export { useSupportingContentTabs } from './useSupportingContentTabs';
